import OperatorInformationReduxSlice from "../new-slices/operator-information";
import CustomerInformationReduxSlice from "../new-slices/customer-information";
import VendorInformationReduxSlice from "../new-slices/vendor-information";
import DialogsReduxSlice from "../new-slices/dialogs";

/**
 * The Actions of the Redux Store state.
 */
const ReduxActions = {
    [OperatorInformationReduxSlice.name]: OperatorInformationReduxSlice.actions,
    [CustomerInformationReduxSlice.name]: CustomerInformationReduxSlice.actions,
    [VendorInformationReduxSlice.name]: VendorInformationReduxSlice.actions,
    [DialogsReduxSlice.name]: DialogsReduxSlice.actions,
}

export default ReduxActions;
